import { Button } from 'common'
import Navigation from 'components/UI/Navigation'
import NavItem from 'components/UI/NavItem'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { logout } from 'user'
import './style.scss'

class MyPageNavigation extends Component {
    render() {
        const { isApp, isLoggedIn, email, dispatch } = this.props
        if (isLoggedIn)
            return (
                <div className="mypage-navigation">
                    <Navigation type="column">
                        <NavItem to={'/my-page/orders'}>Ordrehistorikk</NavItem>
                        <NavItem to={'/my-page/addresses'}>Adresser</NavItem>
                        <NavItem to={'/checkout/payment'}>Betalingsmiddel</NavItem>
                        {isApp && <NavItem to={'/my-page/notifications'}>Varslinger</NavItem>}
                    </Navigation>
                    <div className="mypage-navigation__container mypage-navigation__container__centered">
                        <span className="user-mobile__email">{email}</span>
                    </div>
                    <div className="mypage-navigation__container mypage-navigation__container__centered">
                        <Button type="action" style="primary" onClick={() => dispatch(logout())}>
                            Logg ut
                        </Button>
                    </div>
                </div>
            )
        else return null
    }
}

MyPageNavigation.propTypes = {
    isApp: PropTypes.bool,
    email: PropTypes.string,
    isLoggedIn: PropTypes.bool,
    dispatch: PropTypes.func,
}

function mapStateToProps({ ui, user }) {
    return {
        isApp: ui.isApp,
        isLoggedIn: user.isLoggedIn,
        email: user.jwtData.spidEmail,
    }
}

export default connect(mapStateToProps)(MyPageNavigation)
